import type {
  ComputeRule,
  OptionsByRule,
  RequireAnyOfRule,
  SchemaRule,
  StaticRule,
  ValidateRule,
} from '@tasama/types';

// `staticRules[]` is one heterogeneous array (see SchemaRule) — these narrow a raw entry to
// its real shape. `OptionsByRule` is the only shape with no `effect` key at all.
export function isOptionsByRule(rule: SchemaRule): rule is OptionsByRule {
  return 'optionsBy' in rule;
}

export function isComputeRule(rule: SchemaRule): rule is ComputeRule {
  return 'effect' in rule && rule.effect === 'COMPUTE';
}

export function isRequireAnyOfRule(rule: SchemaRule): rule is RequireAnyOfRule {
  return 'effect' in rule && rule.effect === 'REQUIRE_ANY_OF';
}

export function isValidateRule(rule: SchemaRule): rule is ValidateRule {
  return 'effect' in rule && rule.effect === 'VALIDATE';
}

export function isGroupRule(
  rule: SchemaRule
): rule is RequireAnyOfRule | ValidateRule {
  return isRequireAnyOfRule(rule) || isValidateRule(rule);
}

// Everything left over is a §1/§6 field-state or LABEL rule.
export function isFieldStateRule(rule: SchemaRule): rule is StaticRule {
  return !isOptionsByRule(rule) && !isComputeRule(rule) && !isGroupRule(rule);
}
